import React from 'react';

const NextButton = ({
	text,
	onClick,
	type = 'button',
	variant = 'next',
	customClass = '',
	isDisabled = false,
}) => {
	const baseClasses = 'py-2 md:py-2.5 px-4 text-base md:text-xl rounded-lg border-0 cursor-pointer font-medium';

	const variants = {
		next: 'bg-sfi-light-blue text-white min-w-[140px] disabled:bg-gray-300 disabled:text-gray-500 disabled:opacity-60 disabled:cursor-not-allowed',
		main: 'bg-sfi-blue text-white disabled:bg-gray-300 disabled:text-gray-500 disabled:opacity-60 disabled:cursor-not-allowed',
		transparent: 'bg-transparent text-black',
	};

	return (
		<button
			type={type}
			className={`${baseClasses} ${variants[variant]} ${customClass}`}
			onClick={onClick}
			disabled={isDisabled}
		>
			{text}
		</button>
	);
};

export default NextButton;
